/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleMessages } from '../../_helpers/utilities'
import { IFilters } from '../../_models/commonInterface'
import {
  IDeleteIds,
  IGetFacilityParams,
  IGetRoleParams,
  IInviteFromSuperAdminUserParams,
  IInviteUserState,
  IUserListFilters,
} from '../../_models/superAdmin/businessUsersInterface'
import businessUsersService from '../../_services/superAdmin/businessUsersService'
import { RootState } from '../../_store/store'
import { startLoader, stopLoader } from '../loaderSlice'
import { errorToast, infoToast, successToast } from '../toastSlice'

const initialState: IInviteUserState = {
  inviteUsersList: {
    current_page: 1,
    data: [],
    total: 20,
    per_page: 10,
    last_page: 0,
  },
  isLoadingUsers: false,
  UserListFilter: {
    name: '',
    sort_by: 'name',
    sort_order: 'asc',
    page: 1,
    per_page: 10,
    role_list: [],
  },
  inviteBusinessList: [],
  businessRolesList: [],
  inviteFacilityList: [],
  selectedBusinessId: null,
  isFacilitySelection: false,
  rolePermissions: [],
  allPermissions: [],
  existingUserDetails: {},
  isUserAlreadyInvited: false,
  invitedData: {},
  registeredUser: false,
  openDrawer: false,
  drawerType: 'create',
  businessList: [],
  isReinviteModalOpen: false,
  invitedUserId: null,
  isLastUserPage: false,
  isDeleteModalOpen: false,
  inviteDrawerRoles: [],
}

export const getUsersList = createAsyncThunk(
  '/getUsersList',
  async (filters: IUserListFilters, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getUsersList(filters)
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getInviteBusinessList = createAsyncThunk(
  '/getInviteBusinessList',
  async (filters: IFilters, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getInviteBusinessList(filters)
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getBusinessRolesList = createAsyncThunk(
  '/getBusinessRolesList',
  async (params: IGetRoleParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getBusinessRolesList(params)
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)

export const getInviteDrawerRoles = createAsyncThunk(
  '/getInviteDrawerRoles',
  async (params: IGetRoleParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getBusinessRolesList(params)
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getFacilityList = createAsyncThunk(
  '/getFacilityList',
  async (businessId: IGetFacilityParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getFacilityList(businessId)
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getRolePermissions = createAsyncThunk(
  '/getRolePermissions',
  async (roleId: number, { dispatch, rejectWithValue, getState }) => {
    try {
      const response = await businessUsersService.getRolePermissions(roleId)
      const { selectedBusinessId } = (getState() as RootState).superAdminBusinessUser
      if (selectedBusinessId) {
        dispatch(getFacilityList({ business_id: selectedBusinessId }))
      }
      dispatch(getAllPermissions())

      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getAllPermissions = createAsyncThunk(
  '/getAllPermissions',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getAllPermissions()
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const checkIfUserExits = createAsyncThunk(
  '/checkIfUserExits',
  async (email: string, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const params = {
        email: email,
      }
      const response = await businessUsersService.checkIfUserExits(params)
      if (response.data.user_id) {
        dispatch(isUserRegistered(true))
      }
      dispatch(stopLoader())
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      if (err?.isInfo) {
        dispatch(infoToast(handleMessages(err?.message)))
        dispatch(isUserRegistered(false))
      } else {
        dispatch(errorToast(handleMessages(err?.message)))
      }

      return rejectWithValue(err)
    }
  },
)
export const inviteUserFromSuperAdmin = createAsyncThunk(
  '/inviteUserFromSuperAdmin',
  async (params: IInviteFromSuperAdminUserParams, { dispatch, rejectWithValue, getState }) => {
    dispatch(startLoader())
    try {
      const response = await businessUsersService.inviteUserFromSuperAdmin(params)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response.message)))
      const { UserListFilter } = (getState() as RootState).superAdminBusinessUser
      dispatch(getUsersList(UserListFilter))
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getBusinessList = createAsyncThunk(
  '/getBusinessList',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await businessUsersService.getBusinessList()
      return response
    } catch (err: any) {
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const reInviteUser = createAsyncThunk(
  '/reInviteUser',
  async (userId: number, { dispatch, rejectWithValue, getState }) => {
    dispatch(startLoader())
    const { UserListFilter } = (getState() as RootState).superAdminBusinessUser
    try {
      const response = await businessUsersService.reInviteUser(userId)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response.message)))
      dispatch(getUsersList(UserListFilter))
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const editInvitedUserFromSuperAdmin = createAsyncThunk(
  '/editInvitedUserFromSuperAdmin',
  async (
    { invitationId, params }: { invitationId: number; params: IInviteFromSuperAdminUserParams },
    { dispatch, rejectWithValue, getState },
  ) => {
    dispatch(startLoader())
    const { UserListFilter } = (getState() as RootState).superAdminBusinessUser
    try {
      const response = await businessUsersService.editInvitedUserFromSuperAdmin(
        invitationId,
        params,
      )
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response.message)))

      dispatch(getUsersList(UserListFilter))
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const invitedUserDetails = createAsyncThunk(
  '/invitedUserDetails',
  async (invitationId: number, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await businessUsersService.invitedUserDetails(invitationId)
      if (response.data.user_id) {
        dispatch(isUserRegistered(true))
      }
      dispatch(stopLoader())
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      return rejectWithValue(err)
    }
  },
)
export const deleteUser = createAsyncThunk(
  '/deleteUser',
  async (ids: IDeleteIds, { dispatch, rejectWithValue, getState }) => {
    dispatch(startLoader())

    try {
      const response = await businessUsersService.deleteUser(ids)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response.message)))
      const { superAdminBusinessUser } = getState() as { superAdminBusinessUser: IInviteUserState }
      if (superAdminBusinessUser.isLastUserPage) {
        const isDeletingAllUsersOnPage =
          superAdminBusinessUser.inviteUsersList.data.length > 0 &&
          ids.user_invitation_ids.length === superAdminBusinessUser.inviteUsersList.data.length

        if (isDeletingAllUsersOnPage) {
          const currentPage = superAdminBusinessUser.UserListFilter.page ?? 1
          const previousPage = Math.max(1, currentPage - 1)
          dispatch(
            getUsersList({
              ...superAdminBusinessUser.UserListFilter,
              page: previousPage,
            }),
          )
        } else {
          dispatch(getUsersList(superAdminBusinessUser.UserListFilter))
        }
      } else {
        dispatch(getUsersList(superAdminBusinessUser.UserListFilter))
      }
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const superAdminBusinessUsersSlice = createSlice({
  name: 'superAdminBusinessUser',
  initialState,
  reducers: {
    changeUserFilters: (state, action) => {
      state.UserListFilter = action.payload
    },
    setSelectedBusinessId: (state, action) => {
      state.selectedBusinessId = action.payload
    },

    resetFacilitySelection: (state) => {
      state.isFacilitySelection = initialState.isFacilitySelection
    },
    isUserRegistered: (state, action) => {
      state.registeredUser = action.payload
    },
    openSuperAdminInviteDrawer: (state) => {
      state.openDrawer = true
      state.drawerType = 'create'
    },
    closeSuperAdminInviteDrawer: (state) => {
      state.openDrawer = false
      state.drawerType = 'create'
    },
    resetInvitedData: (state) => {
      state.invitedData = initialState.invitedData
    },
    resetRoleList: (state) => {
      state.inviteDrawerRoles = initialState.businessRolesList
      state.inviteFacilityList = initialState.inviteFacilityList
    },
    resetFacilityList: (state) => {
      state.inviteFacilityList = initialState.inviteFacilityList
    },
    resetDrawerData: (state) => {
      state.invitedData = initialState.invitedData
      state.inviteFacilityList = initialState.inviteFacilityList
      state.inviteDrawerRoles = initialState.inviteDrawerRoles
      state.rolePermissions = initialState.rolePermissions
      state.allPermissions = initialState.allPermissions
      state.existingUserDetails = initialState.existingUserDetails
      state.isUserAlreadyInvited = initialState.isUserAlreadyInvited
      state.selectedBusinessId = initialState.selectedBusinessId
      state.isFacilitySelection = initialState.isFacilitySelection
      state.registeredUser = initialState.registeredUser
    },
    openReinviteModal: (state) => {
      state.isReinviteModalOpen = true
    },
    closeReinviteModal: (state) => {
      state.isReinviteModalOpen = false
    },
    openUserDeleteModal: (state) => {
      state.isDeleteModalOpen = true
    },
    closeUserDeleteModal: (state) => {
      state.isDeleteModalOpen = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsersList.fulfilled, (state, action) => {
      state.inviteUsersList = action.payload.data
      state.UserListFilter.page = state.inviteUsersList.current_page
      state.isLoadingUsers = false
      if (
        state.inviteUsersList.current_page === state.inviteUsersList.last_page &&
        state.inviteUsersList.last_page !== 1
      ) {
        state.isLastUserPage = true
      } else {
        state.isLastUserPage = false
      }
    })
    builder.addCase(getUsersList.pending, (state) => {
      state.isLoadingUsers = true
      // Clear stale data when loading starts
      state.inviteUsersList.data = []
    })
    builder.addCase(getUsersList.rejected, (state) => {
      state.isLoadingUsers = false
    })

    builder.addCase(getInviteBusinessList.fulfilled, (state, action) => {
      state.inviteBusinessList = action.payload.data
    })
    builder.addCase(getBusinessRolesList.fulfilled, (state, action) => {
      state.businessRolesList = action.payload.data.roles.data
      state.isUserAlreadyInvited = action.payload.data.isAlreadyInvited
      state.invitedData = action.payload.data.invitedData
    })
    builder.addCase(getInviteDrawerRoles.fulfilled, (state, action) => {
      state.inviteDrawerRoles = action.payload.data.roles.data
    })
    builder.addCase(getInviteDrawerRoles.rejected, (state) => {
      state.inviteDrawerRoles = initialState.inviteDrawerRoles
    })
    builder.addCase(getFacilityList.fulfilled, (state, action) => {
      state.inviteFacilityList = action.payload.data.facilities
    })
    builder.addCase(getRolePermissions.fulfilled, (state, action) => {
      state.isFacilitySelection = action.payload.data.facility_selection
      state.rolePermissions = action.payload.data.actions
    })
    builder.addCase(getAllPermissions.fulfilled, (state, action) => {
      state.allPermissions = action.payload.data
    })
    builder.addCase(checkIfUserExits.pending, (state) => {
      state.existingUserDetails = initialState.existingUserDetails
    })
    builder.addCase(checkIfUserExits.fulfilled, (state, action) => {
      state.existingUserDetails = action.payload.data
    })
    builder.addCase(checkIfUserExits.rejected, (state) => {
      state.existingUserDetails = initialState.existingUserDetails
    })
    builder.addCase(inviteUserFromSuperAdmin.fulfilled, (state) => {
      state.openDrawer = false
      state.existingUserDetails = initialState.existingUserDetails
    })
    builder.addCase(getBusinessList.fulfilled, (state, action) => {
      state.businessList = action.payload.data || []
    })
    builder.addCase(invitedUserDetails.fulfilled, (state, action) => {
      state.invitedData = action.payload.data
      state.openDrawer = true
      state.drawerType = 'edit'
    })
    builder.addCase(editInvitedUserFromSuperAdmin.fulfilled, (state) => {
      state.openDrawer = false
    })
  },
})

export const {
  changeUserFilters,
  setSelectedBusinessId,
  resetFacilitySelection,
  isUserRegistered,
  openSuperAdminInviteDrawer,
  closeSuperAdminInviteDrawer,
  resetDrawerData,
  resetInvitedData,
  resetRoleList,
  resetFacilityList,
  openReinviteModal,
  closeReinviteModal,
  openUserDeleteModal,
  closeUserDeleteModal,
} = superAdminBusinessUsersSlice.actions

export const superAdminBusinessUsersState = (state: RootState) => state.superAdminBusinessUser
const superAdminBusinessUsersReducer = superAdminBusinessUsersSlice.reducer
export default superAdminBusinessUsersReducer
